import type { PrefabData } from "./prefabData";

export const vendingMachineRoomData: PrefabData = {
	legend: {
		".": "ConcreteFloor",
		E: "EmptyBarrel",
		"#": "ConcreteBlock",
		"/": "WoodenDoor",
		d: "WoodenDesk",
		V: "VendingMachine",
	},
	layers: [[" ####  ", "###### ", "#.V..# ", "#..../ ", "#....# ", "###### ", " #EE#  "]],
};

export const building1Data: PrefabData = {
	legend: {
		"#": "ConcreteBlock",
		".": "ConcreteFloor",
		$: "LootBox",
		"/": "WoodenDoor",
	},
	layers: [
		["   .   ", "  ...  ", " ..... ", "  ...  ", "   .   "],
		["###/###", "##   ##", "#$   $#", "##   ##", "###/###"],
	],
};

export const gasBarrelsWithFenceData: PrefabData = {
	legend: {
		"=": "Fence",
		G: "GasBarrel",
	},
	layout: ["======", "=GGGG=", "=GGGG=", "======"],
};

export const bloodTempleData: PrefabData = {
	legend: {
		B: "BloodPool",
		F: "FireTower",
		"#": "MossBrick",
		M: "MossGate",
	},
	layout: [
		"  #  #  ",
		" ##MM## ",
		" #BBBB# ",
		" FBBBBF ",
		" #BBBB# ",
		"##BBBB##",
		"##BFFB##",
		" #BBBB# ",
		" ###### ",
		"   ##   ",
	],
};

export const smallBloodTempleData: PrefabData = {
	legend: {
		B: "BloodPool",
		F: "FireTower",
		"#": "MossBrick",
		M: "MossGate",
	},
	layout: ["##M##", "#BBB#", "#BFB#", "#BBB#", "##M##"],
};

export const exitTo3xbCaveData: PrefabData = {
	legend: {
		".": "CaveFloor",
		"#": "ConcreteBlock",
		",": "ConcreteFloor",
		E: "EmptyBarrel",
		L: { class: "LadderDown", props: { destination: 0 } },
	},
	layers: [
		["       ", " ,,,   ", " ,,,...", " ,,,   ", "       "],
		["       ", " ...   ", " ...   ", " ...   ", "       "],
		["#####  ", "#E  ###", "#EL    ", "#E  ###", "#####  "],
	],
};

export const caveDescentData: PrefabData = {
	legend: {
		"#": "ConcreteBlock",
		".": "ConcreteFloor",
		D: { class: "Downstairs", props: { destination: 0 } },
		E: "EmptyBarrel",
		A: "ExplosiveBarrel",
		"=": "Fence",
		$: "LootBox",
		"/": "MetalDoor",
		S: { class: "Sign", props: { textKey: "sign_wasteland_outpost" } },
	},
	layers: [
		[
			"...........",
			" .. .......",
			" .. ...... ",
			"...........",
			"...........",
			"...  .  ...",
			"... ... ...",
			"... ... ...",
			"...     ...",
			"...........",
			" ......... ",
		],
		[
			"   S       ",
			"#  #       ",
			"#==#======#",
			"=         =",
			"=  EE     =",
			"=  ##/##$ =",
			"=  #$ $#$ =",
			"=  # D #E =",
			"=AA#####E =",
			"=EEEEEEEEE=",
			"#=========#",
		],
	],
};

export const vaultData: PrefabData = {
	legend: {
		".": "GrayStoneFloor2",
		"#": "MetalBlock",
		"/": "MetalDoor",
	},
	layers: [
		["    .  ", " ..... ", ".......", " ..... ", "  .    "],
		["####/##", "#     #", "/     /", "#     #", "##/####"],
	],
};

export const mobFortress1Data: PrefabData = {
	legend: {
		B: "BigContainer",
		"#": "Rock",
		M: "Slugant",
		"%": "MossBrick",
		A: "MossGate",
		C: "Plant",
	},
	layers: [
		[
			"    % % ",
			" %%%%#% ",
			"%%CC%A%%",
			"%C  M C%",
			"%CC  CC%",
			"%CMB  C%",
			"%CMMM C%",
			"%%A%CC%%",
			" %#%%%% ",
			" % %    ",
		],
		[
			"        ",
			"        ",
			"  MM    ",
			" M    M ",
			" MM   M ",
			" M    M ",
			" M    M ",
			"    MM  ",
			"        ",
			"        ",
		],
	],
};

export const robotFortressData: PrefabData = {
	legend: {
		B: "BigContainer",
		"/": { class: "BlastDoor", props: { group: "" } },
		".": "GraySlab",
		",": "GrayStoneFloor1",
		_: "GrayStoneFloor2",
		$: "LootBox",
		"#": "MetalBlock",
		"+": "MetalDoor",
		O: "OpenBlastDoorsTrap",
		R: { class: "Robot", props: { state: "OFF" } },
	},
	layers: [
		[
			"               ",
			"  ,,,  _  ,,,  ",
			"  ,,, ___ ,,,  ",
			"    , ___ ,    ",
			" ..._______... ",
			" ..._______... ",
			"    , ___ ,    ",
			"  ,,, ___ ,,,  ",
			"  ,,,  _  ,,,  ",
			"               ",
		],
		[
			" #####   ##### ",
			" #RRR##+##RRR# ",
			" #RRR#$ $#RRR# ",
			"####/#   #/####",
			"#B          B #",
			"#      O      #",
			"####/#   #/####",
			" #RRR#$ $#RRR# ",
			" #RRR##+##RRR# ",
			" #####   ##### ",
		],
	],
};
